import z from 'zod';
import { AllCharLabelSchema, SubjectSchema } from '../common/schemas';
import {
  DBVideoResourceSchema,
  DBVideoTopicKeySchema,
  DBVideoVideosEntrySchema,
} from '../videos/schemas';

/**
 * Shared & Helper Schemas
 */
export const DBVideoCategoryTopicShortLabelSchema = AllCharLabelSchema.min(1).max(16);
export const DBVideoCategoryTopicResourcesSchema = z.array(z.lazy(() => DBVideoResourceSchema));
export const DBVideoCategoryTopicVideosSchema = z.array(z.lazy(() => DBVideoVideosEntrySchema));
export const DBVideoCategoryTopicSchema = z.object({
  key: z.lazy(() => DBVideoTopicKeySchema),
  label: AllCharLabelSchema.min(1).max(64),
  resources: DBVideoCategoryTopicResourcesSchema,
  shortLabel: DBVideoCategoryTopicShortLabelSchema,
  videos: DBVideoCategoryTopicVideosSchema,
});

export const VideoCategoryTopicSchema = z.object({
  key: z.lazy(() => DBVideoTopicKeySchema),
  label: AllCharLabelSchema.min(1).max(64),
  resources: DBVideoCategoryTopicResourcesSchema.default([]),
  shortLabel: DBVideoCategoryTopicShortLabelSchema,
  videos: DBVideoCategoryTopicVideosSchema.default([]),
});

/**
 * DB Schemas
 */

export const DBVideoCategorySubjectSchema = SubjectSchema;
export const DBVideoCategoryCategorySchema = z.string().regex(/^[a-zA-Z0-9]{4}$/);
export const DBVideoCategoryLabelSchema = AllCharLabelSchema.min(1).max(64);
export const DBVideoCategoryShortLabelSchema = AllCharLabelSchema.min(1).max(16);
export const DBVideoCategoryTopicsSchema = z.array(DBVideoCategoryTopicSchema);

export const DBVideoCategorySchema = z.object({
  subject: DBVideoCategorySubjectSchema,
  category: DBVideoCategoryCategorySchema,
  label: DBVideoCategoryLabelSchema,
  shortLabel: DBVideoCategoryShortLabelSchema,
  topics: DBVideoCategoryTopicsSchema,
});

/**
 * Client Schemas
 */

export const VideoCategorySubjectSchema = DBVideoCategorySubjectSchema;
export const VideoCategoryCategorySchema = DBVideoCategoryCategorySchema;
export const VideoCategoryLabelSchema = DBVideoCategoryLabelSchema;
export const VideoCategoryShortLabelSchema = DBVideoCategoryShortLabelSchema;
export const VideoCategoryTopicsSchema = z.array(VideoCategoryTopicSchema);

export const VideoCategorySchema = z.object({
  subject: VideoCategorySubjectSchema,
  category: VideoCategoryCategorySchema,
  label: VideoCategoryLabelSchema,
  shortLabel: VideoCategoryShortLabelSchema,
  topics: VideoCategoryTopicsSchema.default([]),
});
